"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetWideSectionPageMarginsCommand = exports.SetModerateSectionPageMarginsCommand = exports.SetNarrowSectionPageMarginsCommand = exports.SetNormalSectionPageMarginsCommand = exports.SetPredefinedSectionPageMarginsCommand = exports.SetSectionPageMarginsCommand = exports.SetSectionPageMarginsCommandBase = void 0;
var tslib_1 = require("tslib");
var section_property_descriptor_1 = require("../../../core/model/section/section-property-descriptor");
var margins_1 = require("@devexpress/utils/lib/geometry/margins");
var client_command_1 = require("../client-command");
var section_properties_command_base_1 = require("./section-properties-command-base");
var SetSectionPageMarginsCommandBase = (function (_super) {
    tslib_1.__extends(SetSectionPageMarginsCommandBase, _super);
    function SetSectionPageMarginsCommandBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SetSectionPageMarginsCommandBase.prototype.getCurrentValue = function () {
        return this.inputPosition.getMergedSectionPropertiesRaw().margins.clone();
    };
    SetSectionPageMarginsCommandBase.prototype.executeCore = function (_state, options) {
        var newValue = options.param;
        if (!this.getCurrentValue().equals(newValue)) {
            section_property_descriptor_1.SectionPropertyDescriptor.marginLeft.setProp(this.inputPosition.getMergedSectionPropertiesRaw(), newValue.left);
            section_property_descriptor_1.SectionPropertyDescriptor.marginTop.setProp(this.inputPosition.getMergedSectionPropertiesRaw(), newValue.top);
            section_property_descriptor_1.SectionPropertyDescriptor.marginRight.setProp(this.inputPosition.getMergedSectionPropertiesRaw(), newValue.right);
            section_property_descriptor_1.SectionPropertyDescriptor.marginBottom.setProp(this.inputPosition.getMergedSectionPropertiesRaw(), newValue.bottom);
            var iter = this.getAffectedSectionsIterator(options.intervalsInfo.intervals);
            this.history.beginTransaction();
            while (iter.moveNext()) {
                var interval = iter.obj.interval;
                this.setMargin(interval, section_property_descriptor_1.SectionPropertyDescriptor.marginLeft, newValue.left);
                this.setMargin(interval, section_property_descriptor_1.SectionPropertyDescriptor.marginTop, newValue.top);
                this.setMargin(interval, section_property_descriptor_1.SectionPropertyDescriptor.marginRight, newValue.right);
                this.setMargin(interval, section_property_descriptor_1.SectionPropertyDescriptor.marginBottom, newValue.bottom);
            }
            this.history.endTransaction();
            return true;
        }
        return false;
    };
    SetSectionPageMarginsCommandBase.prototype.setMargin = function (interval, descriptor, newValue) {
        this.history.addAndRedo(new (descriptor.getHistoryItemConstructor())(this.modelManipulator, interval, newValue));
    };
    SetSectionPageMarginsCommandBase.prototype.getRelatedCommands = function () {
        var _a;
        return _a = {},
            _a[client_command_1.RichEditClientCommand.SetSectionPageMargins] = true,
            _a[client_command_1.RichEditClientCommand.SetNarrowSectionPageMargins] = true,
            _a[client_command_1.RichEditClientCommand.SetNormalSectionPageMargins] = true,
            _a[client_command_1.RichEditClientCommand.SetModerateSectionPageMargins] = true,
            _a[client_command_1.RichEditClientCommand.SetWideSectionPageMargins] = true,
            _a;
    };
    return SetSectionPageMarginsCommandBase;
}(section_properties_command_base_1.SectionPropertiesCommandBase));
exports.SetSectionPageMarginsCommandBase = SetSectionPageMarginsCommandBase;
var SetSectionPageMarginsCommand = (function (_super) {
    tslib_1.__extends(SetSectionPageMarginsCommand, _super);
    function SetSectionPageMarginsCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SetSectionPageMarginsCommand.prototype.getStateValue = function () {
        return this.getCurrentValue();
    };
    return SetSectionPageMarginsCommand;
}(SetSectionPageMarginsCommandBase));
exports.SetSectionPageMarginsCommand = SetSectionPageMarginsCommand;
var SetPredefinedSectionPageMarginsCommand = (function (_super) {
    tslib_1.__extends(SetPredefinedSectionPageMarginsCommand, _super);
    function SetPredefinedSectionPageMarginsCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SetPredefinedSectionPageMarginsCommand.prototype.getStateValue = function () {
        return this.getPredefinedMargins().equals(this.getCurrentValue());
    };
    SetPredefinedSectionPageMarginsCommand.prototype.DEPRECATEDConvertOptionsParameter = function (_parameter) {
        return this.getPredefinedMargins();
    };
    return SetPredefinedSectionPageMarginsCommand;
}(SetSectionPageMarginsCommandBase));
exports.SetPredefinedSectionPageMarginsCommand = SetPredefinedSectionPageMarginsCommand;
var SetNormalSectionPageMarginsCommand = (function (_super) {
    tslib_1.__extends(SetNormalSectionPageMarginsCommand, _super);
    function SetNormalSectionPageMarginsCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SetNormalSectionPageMarginsCommand.prototype.getPredefinedMargins = function () {
        return new margins_1.Margins(1700, 850, 1133, 1133);
    };
    return SetNormalSectionPageMarginsCommand;
}(SetPredefinedSectionPageMarginsCommand));
exports.SetNormalSectionPageMarginsCommand = SetNormalSectionPageMarginsCommand;
var SetNarrowSectionPageMarginsCommand = (function (_super) {
    tslib_1.__extends(SetNarrowSectionPageMarginsCommand, _super);
    function SetNarrowSectionPageMarginsCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SetNarrowSectionPageMarginsCommand.prototype.getPredefinedMargins = function () {
        return new margins_1.Margins(720, 720, 720, 720);
    };
    return SetNarrowSectionPageMarginsCommand;
}(SetPredefinedSectionPageMarginsCommand));
exports.SetNarrowSectionPageMarginsCommand = SetNarrowSectionPageMarginsCommand;
var SetModerateSectionPageMarginsCommand = (function (_super) {
    tslib_1.__extends(SetModerateSectionPageMarginsCommand, _super);
    function SetModerateSectionPageMarginsCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SetModerateSectionPageMarginsCommand.prototype.getPredefinedMargins = function () {
        return new margins_1.Margins(1080, 1080, 1440, 1440);
    };
    return SetModerateSectionPageMarginsCommand;
}(SetPredefinedSectionPageMarginsCommand));
exports.SetModerateSectionPageMarginsCommand = SetModerateSectionPageMarginsCommand;
var SetWideSectionPageMarginsCommand = (function (_super) {
    tslib_1.__extends(SetWideSectionPageMarginsCommand, _super);
    function SetWideSectionPageMarginsCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SetWideSectionPageMarginsCommand.prototype.getPredefinedMargins = function () {
        return new margins_1.Margins(2880, 2880, 1440, 1440);
    };
    return SetWideSectionPageMarginsCommand;
}(SetPredefinedSectionPageMarginsCommand));
exports.SetWideSectionPageMarginsCommand = SetWideSectionPageMarginsCommand;
